import { defineComponent as o, openBlock as c, createBlock as r, unref as p, mergeProps as m, withCtx as d, createElementVNode as e } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconSunFace",
  __name: "IconSunFace",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (i, t) => (c(), r(p(s), m(n, { "view-box": "0 0 48 48" }), {
      default: d(() => [...t[0] || (t[0] = [
        e("g", { "clip-path": "url(#b635b1fa-999e-40d1-968e-47c78b5d0640a)" }, [
          e("path", { d: "M24 0a24 24 0 1 0 0 48 24 24 0 0 0 0-48m3.3 9.336c1.044-.168 2.172 1.38 2.52 3.444s-.204 3.888-1.2 4.044-2.172-1.38-2.52-3.444.168-3.876 1.2-4.044m-7.116.9c1.056 0 1.956 1.656 1.992 3.756s-.78 3.816-1.836 3.84-1.944-1.668-1.98-3.768.768-3.804 1.824-3.828m14.316 8.58a13.4 13.4 0 0 1-3.804 3.192 15.3 15.3 0 0 1-2.292 1.068 17 17 0 0 1-2.46.672 16.15 16.15 0 0 1-9.864-1.284.455.455 0 0 1-.216-.624.49.49 0 0 1 .576-.24 17.87 17.87 0 0 0 9.18.588 17.2 17.2 0 0 0 4.308-1.524c1.38-.7 2.682-1.54 3.888-2.508a.49.49 0 0 1 .672.072.456.456 0 0 1 .012.588" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "b635b1fa-999e-40d1-968e-47c78b5d0640a" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
